export default "__VITE_ASSET__JDTJozJxGXHDx0l7r1KkLg__"